import React, { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import CommentFormContainer from "./CommentFormContainer.jsx";
import CommentListItem from "./CommentListItem.jsx";

export const CommentListItemWrapper = ({
  id,
  editMode,
  onSubmit,
  onCancel,
  userIds,
  parentType,
  parentId,
  projectId,
  orderNumber,
  onEdit,
  onDelete,
  containerTimestamp,
}) => {
  const innerRef = useRef(null);

  const { t } = useTranslation();

  const handleCancel = useCallback(() => {
    typeof onCancel === "function" && onCancel();
    innerRef?.current?.focus({ preventScroll: true });
  }, [onCancel]);

  return (
    <div
      className="comment-wrapper"
      tabIndex="0"
      ref={innerRef}
    >
      {editMode ? (
        <div className="comment">
          <CommentFormContainer
            id={id}
            submitLabel={t("Update Comment")}
            onSubmit={onSubmit}
            onCancel={handleCancel}
            userIds={userIds}
            parentType={parentType}
            parentId={parentId}
            projectId={projectId}
          />
        </div>
      ) : null}
      {!editMode ? (
        <CommentListItem
          id={id}
          orderNumber={orderNumber}
          onEdit={onEdit}
          onDelete={onDelete}
          containerTimestamp={containerTimestamp}
        />
      ) : null}
    </div>
  );
};

CommentListItemWrapper.propTypes = {
  id: PropTypes.number,
  editMode: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  userIds: PropTypes.object,
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  projectId: PropTypes.number,
  orderNumber: PropTypes.number,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  containerTimestamp: PropTypes.number,
};
